import { createI18n } from "vue-i18n";
import ko_validate from "@/i18n/ko/validate.json";
import ko_label from "@/i18n/ko/label.json";

import en_validate from "@/i18n/en/validate.json";
import en_label from "@/i18n/en/label.json";

const i18n = new createI18n({
    locale: 'en',          // 디폴트 언어
    fallbacklocale: 'ko',  // 대체 언어
    messages: {
        'ko': { ...ko_validate, ...ko_label},
        'en': { ...en_validate, ...en_label}
    }
})

export {
    i18n
}